import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const takkSchema = surrealRecordSchema.extend({
  title: z.string(),
  imageUrl: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Takk = z.infer<typeof takkSchema>;
